import {http} from "@/plugins/http";
import {Message, MessageFilter} from "@/model/message";
import {Page} from "@/model/page";

export const messageService = new class MessageService {

  get path (): string {
    return '/message'
  }

  async findByPage (page: number, size: number): Promise<Page<Message>> {
    return (await http.get(this.path + '/', {
      params: {
        page: page,
        size: size
      }
    })).data
  }

  async filter (filter: MessageFilter): Promise<Message[]> {
    const params = {
      page: 0,
      size: 1000
    }
    Object.keys(filter).forEach(param => {
      (params as any)[param] = (filter as any)[param];
    })
    return ((((await http.get(this.path + '/', {params})).data)as Page<Message>).content as Message[])
      .map(c => Object.assign(new Message(),c))
  }

  async findById (id: string): Promise<Message> {
    return (Object.assign(new Message(),(await http.get(this.path + `/${id}`)).data))
  }

  async getStates (): Promise<string[]> {
    return ((await http.get(this.path + '/state')).data as any).states
  }

  async updateState (message: Message): Promise<Message> {
    return ((await http.put(this.path + `/${message.id}/state`,message)).data as any)
  }
}
